import styled from 'styled-components'

import { Alert } from 'app/components/design-system-components/Alert'
import { isDeletedApplicationsAlertEnabled } from 'config/features'

const StyledDeletedApplicationsAlert = styled.div`
  margin-top: 32px;
  margin-bottom: 16px;
`

interface DeletedApplicationsAlertProps {
  deletedCount: number
}

export const DeletedApplicationsAlert = ({
  deletedCount,
}: DeletedApplicationsAlertProps) => {
  // Check feature flag first
  if (!isDeletedApplicationsAlertEnabled()) {
    return null
  }

  if (!deletedCount || deletedCount <= 0) {
    return null
  }

  const messageText = `${deletedCount} application${
    deletedCount === 1 ? '' : 's'
  } ${deletedCount === 1 ? 'has' : 'have'} been deleted.`

  const message = (
    <>
      {messageText}
      &nbsp;
      <a
        href="https://help.snug.com/hc/en-us/articles/4633796966799-Data-Security-and-Privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        learn more
      </a>
    </>
  )

  return (
    <StyledDeletedApplicationsAlert>
      <Alert variant="blueWithBg" showLeftIcon leftIconVariant="info">
        {message}
      </Alert>
    </StyledDeletedApplicationsAlert>
  )
}

export default DeletedApplicationsAlert
